(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    (function () {
var initializedRoots = new WeakSet();
var initializedLabels = new WeakSet();
function initBundleSelectors() {
  document.querySelectorAll('[data-bundle-label]').forEach(function (label) {
    if (initializedLabels.has(label)) return;
    initializedLabels.add(label);
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          label.classList.add('is-visible');
          observer.unobserve(label);
        }
      });
    }, { threshold: 0.6 });

    observer.observe(label);
  });

  document.querySelectorAll('[data-bundle-selector]').forEach(function (root) {
    if (initializedRoots.has(root)) return;
    initializedRoots.add(root);
    var soloVariantId = root.dataset.soloVariantId;
    var accessoryVariantId = root.dataset.accessoryVariantId;
    var soloPrice = parseInt(root.dataset.soloPrice, 10);
    var bundlePrice = parseInt(root.dataset.bundlePrice, 10);
    var submitBtn = root.querySelector('[data-bundle-submit]');
    var priceLabels = root.querySelectorAll('[data-bundle-price-label]');
    var errorEl = root.querySelector('[data-bundle-error]');
    var radios = root.querySelectorAll('input[type="radio"]');

    function updatePriceLabel() {
      var checked = root.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      var formattedPrice = checked.value === 'bundle'
        ? root.dataset.bundlePriceFormatted
        : root.dataset.soloPriceFormatted;
      priceLabels.forEach(function (el) {
        el.textContent = formattedPrice;
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', updatePriceLabel);
    });
    updatePriceLabel();

    submitBtn.addEventListener('click', function () {
      var selected = root.querySelector('input[type="radio"]:checked').value;
      var items = [{ id: soloVariantId, quantity: 1 }];

      if (selected === 'bundle') {
        items.push({ id: accessoryVariantId, quantity: 1 });
      }

      errorEl.hidden = true;
      submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'Could not add to cart');
            });
          }
          return response.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart'
            : '/cart';
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          submitBtn.disabled = false;
        });
    });

    var sizeChartOpenBtn = root.querySelector('[data-size-chart-open]');
    var sizeChartOverlay = root.querySelector('[data-size-chart-overlay]');
    var sizeChartCloseBtn = root.querySelector('[data-size-chart-close]');

    if (sizeChartOpenBtn && sizeChartOverlay) {
      function closeSizeChart() {
        sizeChartOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      sizeChartOpenBtn.addEventListener('click', function () {
        sizeChartOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });

      if (sizeChartCloseBtn) {
        sizeChartCloseBtn.addEventListener('click', closeSizeChart);
      }

      sizeChartOverlay.addEventListener('click', function (e) {
        if (e.target === sizeChartOverlay) closeSizeChart();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sizeChartOverlay.classList.contains('is-open')) {
          closeSizeChart();
        }
      });
    }
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBundleSelectors, { once: true });
} else {
  initBundleSelectors();
}
document.addEventListener('shopify:section:load', initBundleSelectors);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bundle-selectorcopy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-bundle-label-copy]').forEach(function (label) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          label.classList.add('is-visible');
          observer.unobserve(label);
        }
      });
    }, { threshold: 0.6 });

    observer.observe(label);
  });

  document.querySelectorAll('[data-bundle-selector-copy]').forEach(function (root) {
    var soloVariantId = root.dataset.soloVariantId;
    var accessoryVariantId = root.dataset.accessoryVariantId;
    var soloPrice = parseInt(root.dataset.soloPrice, 10);
    var bundlePrice = parseInt(root.dataset.bundlePrice, 10);
    var submitBtn = root.querySelector('[data-bundle-submit-copy]');
    var priceLabels = root.querySelectorAll('[data-bundle-price-label-copy]');
    var errorEl = root.querySelector('[data-bundle-error-copy]');
    var radios = root.querySelectorAll('input[type="radio"]');

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format || null);
      }
      return (cents / 100).toFixed(2);
    }

    function updatePriceLabel() {
      var selected = root.querySelector('input[type="radio"]:checked').value;
      var total = selected === 'bundle' ? bundlePrice : soloPrice;
      priceLabels.forEach(function (el) {
        el.textContent = formatMoney(total);
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', updatePriceLabel);
    });

    submitBtn.addEventListener('click', function () {
      var selected = root.querySelector('input[type="radio"]:checked').value;
      var items = [{ id: soloVariantId, quantity: 1 }];

      if (selected === 'bundle') {
        items.push({ id: accessoryVariantId, quantity: 1 });
      }

      errorEl.hidden = true;
      submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'Could not add to cart');
            });
          }
          return response.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart'
            : '/cart';
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          submitBtn.disabled = false;
        });
    });

    var sizeChartOpenBtn = root.querySelector('[data-size-chart-open-copy]');
    var sizeChartOverlay = root.querySelector('[data-size-chart-overlay-copy]');
    var sizeChartCloseBtn = root.querySelector('[data-size-chart-close-copy]');

    if (sizeChartOpenBtn && sizeChartOverlay) {
      function closeSizeChart() {
        sizeChartOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      sizeChartOpenBtn.addEventListener('click', function () {
        sizeChartOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });

      if (sizeChartCloseBtn) {
        sizeChartCloseBtn.addEventListener('click', closeSizeChart);
      }

      sizeChartOverlay.addEventListener('click', function (e) {
        if (e.target === sizeChartOverlay) closeSizeChart();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sizeChartOverlay.classList.contains('is-open')) {
          closeSizeChart();
        }
      });
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["stock-warning"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-stock-warning]').forEach(function (block) {
  var sweepEl = block.querySelector('[data-radar-sweep]');
  var radarBox = block.querySelector('[data-radar-box]');
  if (!sweepEl || !radarBox) return;

  var sensitivity = parseFloat(block.getAttribute('data-scroll-sensitivity')) || 0.6;
  var rotation = 0;
  var lastScrollY = window.scrollY;
  var ticking = false;

  function updateRadar() {
    var currentScrollY = window.scrollY;
    var delta = currentScrollY - lastScrollY;
    lastScrollY = currentScrollY;
    
    rotation += delta * sensitivity;

    var baseScale = 1.0;
    var scale = baseScale + (currentScrollY * 0.0012);

    radarBox.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
    sweepEl.style.transform = 'rotate(' + rotation + 'deg)';
    
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateRadar);
      ticking = true;
    }
  }, { passive: true });
});

// Intersection observer to trigger animations when visible
(function() {
  const container = document.currentScript ? document.currentScript.previousElementSibling : document.querySelector('.stock-folder-container-{{ block.id }}');
  if (!container) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  observer.observe(container);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["stock-warningcopy"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-stock-warning]').forEach(function (block) {
  var sweepEl = block.querySelector('[data-radar-sweep]');
  var radarBox = block.querySelector('[data-radar-box]');
  if (!sweepEl || !radarBox) return;

  var sensitivity = parseFloat(block.getAttribute('data-scroll-sensitivity')) || 0.6;
  var rotation = 0;
  var lastScrollY = window.scrollY;
  var ticking = false;

  function updateRadar() {
    var currentScrollY = window.scrollY;
    var delta = currentScrollY - lastScrollY;
    lastScrollY = currentScrollY;
    
    rotation += delta * sensitivity;

    var baseScale = 1.0;
    var scale = baseScale + (currentScrollY * 0.0012);

    radarBox.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
    sweepEl.style.transform = 'rotate(' + rotation + 'deg)';
    
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateRadar);
      ticking = true;
    }
  }, { passive: true });
});

/* Krymp & blur vid nedscrollning (endast mobil), reverseras vid uppscrollning */
(function() {
  if (window.innerWidth > 768) return;

  const container = document.querySelector('.stock-folder-container-{{ block.id }}');
  if (!container) return;

  let progress = 0;
  let lastScrollY = window.scrollY;
  let ticking = false;

  const maxScaleReduction = 0.2;  // krymper till 80% vid full effekt
  const maxBlur = 10;             // px vid full effekt
  const maxOpacityReduction = 0.8; // tonar ner till 20% opacitet vid full effekt
  const sensitivity = 400;        // px scroll som krävs för full effekt (lägre = snabbare)

  function applyEffect() {
    const scaleVal = 1 - (progress * maxScaleReduction);
    const blurVal = progress * maxBlur;
    const opacityVal = 1 - (progress * maxOpacityReduction);

    container.style.filter = `blur(${blurVal}px)`;
    container.style.transform = `scale(${scaleVal})`;
    container.style.opacity = opacityVal;

    ticking = false;
  }

  window.addEventListener('scroll', function () {
    const currentScrollY = window.scrollY;
    const delta = currentScrollY - lastScrollY;
    lastScrollY = currentScrollY;

    progress += delta / sensitivity;
    if (progress > 1) progress = 1;
    if (progress < 0) progress = 0;

    if (!ticking) {
      requestAnimationFrame(applyEffect);
      ticking = true;
    }
  }, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

})();
